import {
  PublicKeyCredentialCreationOptionsJSON,
  PublicKeyCredentialRequestOptionsJSON,
  startAuthentication,
  startRegistration,
} from "@simplewebauthn/browser";
import {
  AddPasskeyPayload,
  Passkey,
  PasskeyAutheticatePayload,
  PasskeyRegisterPayload,
  SignInWithPasskeyPayload,
  VerifyPasskeyAuthenticationPayload,
  VerifyPasskeyRegistrationPayload,
} from "@/types/ApiResponses/Passkey";
import { NewSession } from "@/types/ApiResponses/SessionNew";
import { api } from "..";
import { QueryProps } from "@/types/Api";

export const getPasskeys = async (props: QueryProps): Promise<Passkey[]> => {
  const res = await api.client.get("/auth-new/passkeys", {
    signal: props.signal,
  });
  return res.data;
};

export const signInWithPasskey = async (
  payload: SignInWithPasskeyPayload
): Promise<{ session: NewSession }> => {
  const options = await generateAuthenticateOptions({
    username: payload.username,
  });

  const response = await startAuthentication({
    useBrowserAutofill: payload.autoFill,
    optionsJSON: options,
  });

  return verifyAuthentication({
    response,
  });
};

export const addPasskey = async (
  payload: AddPasskeyPayload
): Promise<Passkey> => {
  const options = await generateRegisterOptions({
    name: payload.name,
  });

  const response = await startRegistration({
    optionsJSON: options,
  });

  return verifyRegistration({
    name: options.user.name,
    response,
  });
};

export const deletePasskey = async (id: string): Promise<void> => {
  const res = await api.client.delete(`/auth-new/passkeys/${id}`);
  return res.data;
};

export const generateAuthenticateOptions = async (
  payload: PasskeyAutheticatePayload
): Promise<PublicKeyCredentialRequestOptionsJSON> => {
  const res = await api.client.post(
    "/auth-new/passkeys/generate-authenticate-options",
    payload
  );
  return res.data;
};

export const verifyAuthentication = async (
  payload: VerifyPasskeyAuthenticationPayload
): Promise<{ session: NewSession }> => {
  const res = await api.client.post(
    "/auth-new/passkeys/verify-authentication",
    payload
  );
  return res.data;
};

export const generateRegisterOptions = async (
  payload: PasskeyRegisterPayload
): Promise<PublicKeyCredentialCreationOptionsJSON> => {
  const res = await api.client.post(
    "/auth-new/passkeys/generate-register-options",
    payload
  );
  return res.data;
};

export const verifyRegistration = async (
  payload: VerifyPasskeyRegistrationPayload
): Promise<Passkey> => {
  const res = await api.client.post(
    "/auth-new/passkeys/verify-registration",
    payload
  );
  return res.data;
};
